import { useEffect } from "react";
import type { Language } from "../contexts/types";

type PublicPageMeta = {
  language: Language;
  title: string;
  description: string;
  imageTitle?: string;
  imageDescription?: string;
};

const HTML_LANG_BY_LANGUAGE: Record<Language, string> = {
  pt: "pt-BR",
  en: "en",
  es: "es",
};

const ensureMetaTag = (selector: string, attribute: "name" | "property", value: string) => {
  if (typeof document === "undefined") return null;

  let tag = document.head.querySelector<HTMLMetaElement>(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, value);
    document.head.appendChild(tag);
  }
  return tag;
};

export const usePublicPageMeta = ({
  language,
  title,
  description,
  imageTitle,
  imageDescription,
}: PublicPageMeta) => {
  useEffect(() => {
    if (typeof document === "undefined") return;

    document.documentElement.lang = HTML_LANG_BY_LANGUAGE[language];
    document.title = title;

    const descriptionTag = ensureMetaTag('meta[name="description"]', "name", "description");
    if (descriptionTag) descriptionTag.content = description;

    const ogTitleTag = ensureMetaTag('meta[property="og:title"]', "property", "og:title");
    if (ogTitleTag) ogTitleTag.content = imageTitle || title;

    const ogDescriptionTag = ensureMetaTag('meta[property="og:description"]', "property", "og:description");
    if (ogDescriptionTag) ogDescriptionTag.content = imageDescription || description;
  }, [language, title, description, imageTitle, imageDescription]);
};
